import { useDisplayPage } from '../../hooks/usePage';
import useWindowSize from '../../hooks/useWindowSize';
import { getComponentFromName } from '../../lib/utils';

import { LiveDisplayProvider } from '../../contexts/LiveDisplayContext';
import * as Components from '../displays/displays';

function DisplayPage() {
    const { page, refetch } = useDisplayPage();
    const { component = null } = page || {};
    const { width, height } = useWindowSize();
    const Component = getComponentFromName(Components, component, 'sport') || null;
    const children = Component !== null ? <Component vertical={height > width} /> : null;

    return (
        <LiveDisplayProvider
            display={page}
            followCurrentGame={component === 'screens' || component === 'live_quiz_controller'}
            refetch={refetch}
        >
            {children}
        </LiveDisplayProvider>
    );
}

export default DisplayPage;
